export default __webpack_public_path__ + "static/media/Nieve.408a126c.jpg";